// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  backendApiAdminLevelsCreateAdminLevelUser,
  backendApiAdminLevelsFindAll,
  backendApiAdminLevelsFindOne,
  backendApiAdminLevelsFindOneAdminLevelUser,
  backendApiAdminLevelsRemoveAdminLevelUser,
  backendApiAdminLevelsUpdate,
  backendApiAdminLevelsUpdateAdminLevelUser,
  backendApiAuthenticationGetUser,
  backendApiAuthenticationLogin,
  backendApiAuthenticationLogout,
  backendApiAuthenticationSamlAssertionConsumer,
  backendApiAuthenticationSamlLogout,
  backendApiAuthenticationSamlMetadata,
  backendApiAuthenticationSamlSingleLogout,
  backendApiCaslGetRules,
  backendApiDashboardAnalyze,
  backendApiExternalReportsCreate,
  backendApiExternalReportsGetCategories,
  backendApiExternalReportsGetStatus,
  backendApiExternalReportsTest,
  backendApiGeocoderGeocode,
  backendApiGeocoderReverse,
  backendApiHealthCheck,
  backendApiRadvisImportImportBicycleNetwork,
  backendApiRadvisImportImportRouteSigns,
  backendApiRadvisImportImportServiceStations,
  backendApiReportCategoriesCreate,
  backendApiReportCategoriesFindAll,
  backendApiReportCategoriesFindOne,
  backendApiReportCategoriesUpdate,
  backendApiReportImagesFindOne,
  backendApiReportImagesUpload,
  backendApiReportResponsibilityCheck,
  backendApiReportResponsibilityGetAdminLevels,
  backendApiReportsCreate,
  backendApiReportsCreateAdminLevel,
  backendApiReportsCreateComment,
  backendApiReportsCreateForwarding,
  backendApiReportsCreatePriority,
  backendApiReportsCreatePublication,
  backendApiReportsCreateStatus,
  backendApiReportsCreateUser,
  backendApiReportsFindAll,
  backendApiReportsFindOne,
  backendApiReportsRemove,
  backendApiReportsTriggerNotifications,
  backendApiReportsUpdate,
  backendApiSystemNotificationsCreate,
  backendApiSystemNotificationsFindAll,
  backendApiSystemNotificationsFindOne,
  backendApiSystemNotificationsRemove,
  backendApiSystemNotificationsUpdate,
  backendApiUsersCreate,
  backendApiUsersFindAll,
  backendApiUsersFindOne,
  backendApiUsersRemove,
  backendApiUsersUpdate,
  type Options,
} from '../sdk.gen';
import type {
  AdminLevelsCreateAdminLevelUserData,
  AdminLevelsCreateAdminLevelUserResponse,
  AdminLevelsFindAllData,
  AdminLevelsFindAllResponse,
  AdminLevelsFindOneAdminLevelUserData,
  AdminLevelsFindOneAdminLevelUserResponse,
  AdminLevelsFindOneData,
  AdminLevelsFindOneResponse,
  AdminLevelsRemoveAdminLevelUserData,
  AdminLevelsRemoveAdminLevelUserResponse,
  AdminLevelsUpdateAdminLevelUserData,
  AdminLevelsUpdateAdminLevelUserResponse,
  AdminLevelsUpdateData,
  AdminLevelsUpdateResponse,
  AuthenticationGetUserData,
  AuthenticationGetUserResponse,
  AuthenticationLoginData,
  AuthenticationLogoutData,
  AuthenticationSamlAssertionConsumerData,
  AuthenticationSamlLogoutData,
  AuthenticationSamlMetadataData,
  AuthenticationSamlMetadataResponse,
  AuthenticationSamlSingleLogoutData,
  CaslGetRulesData,
  CaslGetRulesResponse,
  DashboardAnalyzeData,
  DashboardAnalyzeResponse,
  ExternalReportsCreateData,
  ExternalReportsCreateResponse,
  ExternalReportsGetCategoriesData,
  ExternalReportsGetCategoriesResponse,
  ExternalReportsGetStatusData,
  ExternalReportsGetStatusResponse,
  ExternalReportsTestData,
  ExternalReportsTestResponse,
  GeocoderGeocodeData,
  GeocoderGeocodeResponse,
  GeocoderReverseData,
  GeocoderReverseResponse,
  HealthCheckData,
  HealthCheckError,
  HealthCheckResponse,
  RadvisImportImportBicycleNetworkData,
  RadvisImportImportBicycleNetworkResponse,
  RadvisImportImportRouteSignsData,
  RadvisImportImportRouteSignsResponse,
  RadvisImportImportServiceStationsData,
  RadvisImportImportServiceStationsResponse,
  ReportCategoriesCreateData,
  ReportCategoriesCreateResponse,
  ReportCategoriesFindAllData,
  ReportCategoriesFindAllResponse,
  ReportCategoriesFindOneData,
  ReportCategoriesFindOneResponse,
  ReportCategoriesUpdateData,
  ReportCategoriesUpdateResponse,
  ReportImagesFindOneData,
  ReportImagesFindOneResponse,
  ReportImagesUploadData,
  ReportImagesUploadResponse,
  ReportResponsibilityCheckData,
  ReportResponsibilityCheckResponse,
  ReportResponsibilityGetAdminLevelsData,
  ReportResponsibilityGetAdminLevelsResponse,
  ReportsCreateAdminLevelData,
  ReportsCreateAdminLevelResponse,
  ReportsCreateCommentData,
  ReportsCreateCommentResponse,
  ReportsCreateData,
  ReportsCreateForwardingData,
  ReportsCreateForwardingResponse,
  ReportsCreatePriorityData,
  ReportsCreatePriorityResponse,
  ReportsCreatePublicationData,
  ReportsCreatePublicationResponse,
  ReportsCreateResponse,
  ReportsCreateStatusData,
  ReportsCreateStatusResponse,
  ReportsCreateUserData,
  ReportsCreateUserResponse,
  ReportsFindAllData,
  ReportsFindAllResponse,
  ReportsFindOneData,
  ReportsFindOneResponse,
  ReportsRemoveData,
  ReportsRemoveResponse,
  ReportsTriggerNotificationsData,
  ReportsUpdateData,
  ReportsUpdateResponse,
  SystemNotificationsCreateData,
  SystemNotificationsCreateResponse,
  SystemNotificationsFindAllData,
  SystemNotificationsFindAllResponse,
  SystemNotificationsFindOneData,
  SystemNotificationsFindOneResponse,
  SystemNotificationsRemoveData,
  SystemNotificationsRemoveResponse,
  SystemNotificationsUpdateData,
  SystemNotificationsUpdateResponse,
  UsersCreateData,
  UsersCreateResponse,
  UsersFindAllData,
  UsersFindAllResponse,
  UsersFindOneData,
  UsersFindOneResponse,
  UsersRemoveData,
  UsersRemoveResponse,
  UsersUpdateData,
  UsersUpdateResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const backendApiHealthCheckQueryKey = (options?: Options<HealthCheckData>) =>
  createQueryKey('healthCheck', options);

export const backendApiHealthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<
    HealthCheckResponse,
    HealthCheckError,
    HealthCheckResponse,
    ReturnType<typeof backendApiHealthCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiHealthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiHealthCheckQueryKey(options),
  });

export const backendApiAuthenticationLoginQueryKey = (options?: Options<AuthenticationLoginData>) =>
  createQueryKey('authenticationLogin', options);

export const backendApiAuthenticationLoginOptions = (options?: Options<AuthenticationLoginData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationLoginQueryKey(options),
  });

export const backendApiAuthenticationSamlAssertionConsumerQueryKey = (
  options?: Options<AuthenticationSamlAssertionConsumerData>,
) => createQueryKey('authenticationSamlAssertionConsumer', options);

export const backendApiAuthenticationSamlAssertionConsumerOptions = (
  options?: Options<AuthenticationSamlAssertionConsumerData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof backendApiAuthenticationSamlAssertionConsumerQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlAssertionConsumer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlAssertionConsumerQueryKey(options),
  });

export const backendApiAuthenticationSamlAssertionConsumerMutation = (
  options?: Partial<Options<AuthenticationSamlAssertionConsumerData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlAssertionConsumerData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlAssertionConsumerData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationSamlAssertionConsumer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationLogoutQueryKey = (options?: Options<AuthenticationLogoutData>) =>
  createQueryKey('authenticationLogout', options);

export const backendApiAuthenticationLogoutOptions = (options?: Options<AuthenticationLogoutData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationLogoutQueryKey(options),
  });

export const backendApiAuthenticationLogoutMutation = (
  options?: Partial<Options<AuthenticationLogoutData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationSamlLogoutQueryKey = (options?: Options<AuthenticationSamlLogoutData>) =>
  createQueryKey('authenticationSamlLogout', options);

export const backendApiAuthenticationSamlLogoutOptions = (options?: Options<AuthenticationSamlLogoutData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationSamlLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlLogoutQueryKey(options),
  });

export const backendApiAuthenticationSamlLogoutMutation = (
  options?: Partial<Options<AuthenticationSamlLogoutData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationSamlLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationSamlSingleLogoutQueryKey = (
  options?: Options<AuthenticationSamlSingleLogoutData>,
) => createQueryKey('authenticationSamlSingleLogout', options);

export const backendApiAuthenticationSamlSingleLogoutOptions = (
  options?: Options<AuthenticationSamlSingleLogoutData>,
) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationSamlSingleLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlSingleLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlSingleLogoutQueryKey(options),
  });

export const backendApiAuthenticationSamlMetadataQueryKey = (options?: Options<AuthenticationSamlMetadataData>) =>
  createQueryKey('authenticationSamlMetadata', options);

export const backendApiAuthenticationSamlMetadataOptions = (options?: Options<AuthenticationSamlMetadataData>) =>
  queryOptions<
    AuthenticationSamlMetadataResponse,
    DefaultError,
    AuthenticationSamlMetadataResponse,
    ReturnType<typeof backendApiAuthenticationSamlMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlMetadataQueryKey(options),
  });

export const backendApiAuthenticationGetUserQueryKey = (options?: Options<AuthenticationGetUserData>) =>
  createQueryKey('authenticationGetUser', options);

export const backendApiAuthenticationGetUserOptions = (options?: Options<AuthenticationGetUserData>) =>
  queryOptions<
    AuthenticationGetUserResponse,
    DefaultError,
    AuthenticationGetUserResponse,
    ReturnType<typeof backendApiAuthenticationGetUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationGetUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationGetUserQueryKey(options),
  });

export const backendApiCaslGetRulesQueryKey = (options?: Options<CaslGetRulesData>) =>
  createQueryKey('caslGetRules', options);

export const backendApiCaslGetRulesOptions = (options?: Options<CaslGetRulesData>) =>
  queryOptions<
    CaslGetRulesResponse,
    DefaultError,
    CaslGetRulesResponse,
    ReturnType<typeof backendApiCaslGetRulesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiCaslGetRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiCaslGetRulesQueryKey(options),
  });

export const backendApiUsersFindAllQueryKey = (options?: Options<UsersFindAllData>) =>
  createQueryKey('usersFindAll', options);

export const backendApiUsersFindAllOptions = (options?: Options<UsersFindAllData>) =>
  queryOptions<
    UsersFindAllResponse,
    DefaultError,
    UsersFindAllResponse,
    ReturnType<typeof backendApiUsersFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindAllQueryKey(options),
  });

export const backendApiUsersCreateQueryKey = (options: Options<UsersCreateData>) =>
  createQueryKey('usersCreate', options);

export const backendApiUsersCreateOptions = (options: Options<UsersCreateData>) =>
  queryOptions<
    UsersCreateResponse,
    DefaultError,
    UsersCreateResponse,
    ReturnType<typeof backendApiUsersCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersCreateQueryKey(options),
  });

export const backendApiUsersCreateMutation = (
  options?: Partial<Options<UsersCreateData>>,
): UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> => {
  const mutationOptions: UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersRemoveMutation = (
  options?: Partial<Options<UsersRemoveData>>,
): UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> => {
  const mutationOptions: UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersFindOneQueryKey = (options: Options<UsersFindOneData>) =>
  createQueryKey('usersFindOne', options);

export const backendApiUsersFindOneOptions = (options: Options<UsersFindOneData>) =>
  queryOptions<
    UsersFindOneResponse,
    DefaultError,
    UsersFindOneResponse,
    ReturnType<typeof backendApiUsersFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindOneQueryKey(options),
  });

export const backendApiUsersUpdateMutation = (
  options?: Partial<Options<UsersUpdateData>>,
): UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> => {
  const mutationOptions: UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsFindAllQueryKey = (options?: Options<ReportsFindAllData>) =>
  createQueryKey('reportsFindAll', options);

export const backendApiReportsFindAllOptions = (options?: Options<ReportsFindAllData>) =>
  queryOptions<
    ReportsFindAllResponse,
    DefaultError,
    ReportsFindAllResponse,
    ReturnType<typeof backendApiReportsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsFindAllQueryKey(options),
  });

export const backendApiReportsCreateQueryKey = (options: Options<ReportsCreateData>) =>
  createQueryKey('reportsCreate', options);

export const backendApiReportsCreateOptions = (options: Options<ReportsCreateData>) =>
  queryOptions<
    ReportsCreateResponse,
    DefaultError,
    ReportsCreateResponse,
    ReturnType<typeof backendApiReportsCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateQueryKey(options),
  });

export const backendApiReportsCreateMutation = (
  options?: Partial<Options<ReportsCreateData>>,
): UseMutationOptions<ReportsCreateResponse, DefaultError, Options<ReportsCreateData>> => {
  const mutationOptions: UseMutationOptions<ReportsCreateResponse, DefaultError, Options<ReportsCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsRemoveMutation = (
  options?: Partial<Options<ReportsRemoveData>>,
): UseMutationOptions<ReportsRemoveResponse, DefaultError, Options<ReportsRemoveData>> => {
  const mutationOptions: UseMutationOptions<ReportsRemoveResponse, DefaultError, Options<ReportsRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsFindOneQueryKey = (options: Options<ReportsFindOneData>) =>
  createQueryKey('reportsFindOne', options);

export const backendApiReportsFindOneOptions = (options: Options<ReportsFindOneData>) =>
  queryOptions<
    ReportsFindOneResponse,
    DefaultError,
    ReportsFindOneResponse,
    ReturnType<typeof backendApiReportsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsFindOneQueryKey(options),
  });

export const backendApiReportsUpdateMutation = (
  options?: Partial<Options<ReportsUpdateData>>,
): UseMutationOptions<ReportsUpdateResponse, DefaultError, Options<ReportsUpdateData>> => {
  const mutationOptions: UseMutationOptions<ReportsUpdateResponse, DefaultError, Options<ReportsUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreateAdminLevelQueryKey = (options: Options<ReportsCreateAdminLevelData>) =>
  createQueryKey('reportsCreateAdminLevel', options);

export const backendApiReportsCreateAdminLevelOptions = (options: Options<ReportsCreateAdminLevelData>) =>
  queryOptions<
    ReportsCreateAdminLevelResponse,
    DefaultError,
    ReportsCreateAdminLevelResponse,
    ReturnType<typeof backendApiReportsCreateAdminLevelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreateAdminLevel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateAdminLevelQueryKey(options),
  });

export const backendApiReportsCreateAdminLevelMutation = (
  options?: Partial<Options<ReportsCreateAdminLevelData>>,
): UseMutationOptions<ReportsCreateAdminLevelResponse, DefaultError, Options<ReportsCreateAdminLevelData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreateAdminLevelResponse,
    DefaultError,
    Options<ReportsCreateAdminLevelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreateAdminLevel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreateCommentQueryKey = (options: Options<ReportsCreateCommentData>) =>
  createQueryKey('reportsCreateComment', options);

export const backendApiReportsCreateCommentOptions = (options: Options<ReportsCreateCommentData>) =>
  queryOptions<
    ReportsCreateCommentResponse,
    DefaultError,
    ReportsCreateCommentResponse,
    ReturnType<typeof backendApiReportsCreateCommentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreateComment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateCommentQueryKey(options),
  });

export const backendApiReportsCreateCommentMutation = (
  options?: Partial<Options<ReportsCreateCommentData>>,
): UseMutationOptions<ReportsCreateCommentResponse, DefaultError, Options<ReportsCreateCommentData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreateCommentResponse,
    DefaultError,
    Options<ReportsCreateCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreateComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreatePriorityQueryKey = (options: Options<ReportsCreatePriorityData>) =>
  createQueryKey('reportsCreatePriority', options);

export const backendApiReportsCreatePriorityOptions = (options: Options<ReportsCreatePriorityData>) =>
  queryOptions<
    ReportsCreatePriorityResponse,
    DefaultError,
    ReportsCreatePriorityResponse,
    ReturnType<typeof backendApiReportsCreatePriorityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreatePriority({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreatePriorityQueryKey(options),
  });

export const backendApiReportsCreatePriorityMutation = (
  options?: Partial<Options<ReportsCreatePriorityData>>,
): UseMutationOptions<ReportsCreatePriorityResponse, DefaultError, Options<ReportsCreatePriorityData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreatePriorityResponse,
    DefaultError,
    Options<ReportsCreatePriorityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreatePriority({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreatePublicationQueryKey = (options: Options<ReportsCreatePublicationData>) =>
  createQueryKey('reportsCreatePublication', options);

export const backendApiReportsCreatePublicationOptions = (options: Options<ReportsCreatePublicationData>) =>
  queryOptions<
    ReportsCreatePublicationResponse,
    DefaultError,
    ReportsCreatePublicationResponse,
    ReturnType<typeof backendApiReportsCreatePublicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreatePublication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreatePublicationQueryKey(options),
  });

export const backendApiReportsCreatePublicationMutation = (
  options?: Partial<Options<ReportsCreatePublicationData>>,
): UseMutationOptions<ReportsCreatePublicationResponse, DefaultError, Options<ReportsCreatePublicationData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreatePublicationResponse,
    DefaultError,
    Options<ReportsCreatePublicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreatePublication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreateStatusQueryKey = (options: Options<ReportsCreateStatusData>) =>
  createQueryKey('reportsCreateStatus', options);

export const backendApiReportsCreateStatusOptions = (options: Options<ReportsCreateStatusData>) =>
  queryOptions<
    ReportsCreateStatusResponse,
    DefaultError,
    ReportsCreateStatusResponse,
    ReturnType<typeof backendApiReportsCreateStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreateStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateStatusQueryKey(options),
  });

export const backendApiReportsCreateStatusMutation = (
  options?: Partial<Options<ReportsCreateStatusData>>,
): UseMutationOptions<ReportsCreateStatusResponse, DefaultError, Options<ReportsCreateStatusData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreateStatusResponse,
    DefaultError,
    Options<ReportsCreateStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreateStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreateUserQueryKey = (options: Options<ReportsCreateUserData>) =>
  createQueryKey('reportsCreateUser', options);

export const backendApiReportsCreateUserOptions = (options: Options<ReportsCreateUserData>) =>
  queryOptions<
    ReportsCreateUserResponse,
    DefaultError,
    ReportsCreateUserResponse,
    ReturnType<typeof backendApiReportsCreateUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateUserQueryKey(options),
  });

export const backendApiReportsCreateUserMutation = (
  options?: Partial<Options<ReportsCreateUserData>>,
): UseMutationOptions<ReportsCreateUserResponse, DefaultError, Options<ReportsCreateUserData>> => {
  const mutationOptions: UseMutationOptions<ReportsCreateUserResponse, DefaultError, Options<ReportsCreateUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreateUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsCreateForwardingQueryKey = (options: Options<ReportsCreateForwardingData>) =>
  createQueryKey('reportsCreateForwarding', options);

export const backendApiReportsCreateForwardingOptions = (options: Options<ReportsCreateForwardingData>) =>
  queryOptions<
    ReportsCreateForwardingResponse,
    DefaultError,
    ReportsCreateForwardingResponse,
    ReturnType<typeof backendApiReportsCreateForwardingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsCreateForwarding({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsCreateForwardingQueryKey(options),
  });

export const backendApiReportsCreateForwardingMutation = (
  options?: Partial<Options<ReportsCreateForwardingData>>,
): UseMutationOptions<ReportsCreateForwardingResponse, DefaultError, Options<ReportsCreateForwardingData>> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreateForwardingResponse,
    DefaultError,
    Options<ReportsCreateForwardingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsCreateForwarding({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportsTriggerNotificationsQueryKey = (options: Options<ReportsTriggerNotificationsData>) =>
  createQueryKey('reportsTriggerNotifications', options);

export const backendApiReportsTriggerNotificationsOptions = (options: Options<ReportsTriggerNotificationsData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiReportsTriggerNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportsTriggerNotifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportsTriggerNotificationsQueryKey(options),
  });

export const backendApiReportsTriggerNotificationsMutation = (
  options?: Partial<Options<ReportsTriggerNotificationsData>>,
): UseMutationOptions<unknown, DefaultError, Options<ReportsTriggerNotificationsData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ReportsTriggerNotificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportsTriggerNotifications({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportResponsibilityGetAdminLevelsQueryKey = (
  options: Options<ReportResponsibilityGetAdminLevelsData>,
) => createQueryKey('reportResponsibilityGetAdminLevels', options);

export const backendApiReportResponsibilityGetAdminLevelsOptions = (
  options: Options<ReportResponsibilityGetAdminLevelsData>,
) =>
  queryOptions<
    ReportResponsibilityGetAdminLevelsResponse,
    DefaultError,
    ReportResponsibilityGetAdminLevelsResponse,
    ReturnType<typeof backendApiReportResponsibilityGetAdminLevelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportResponsibilityGetAdminLevels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportResponsibilityGetAdminLevelsQueryKey(options),
  });

export const backendApiReportResponsibilityCheckQueryKey = (options: Options<ReportResponsibilityCheckData>) =>
  createQueryKey('reportResponsibilityCheck', options);

export const backendApiReportResponsibilityCheckOptions = (options: Options<ReportResponsibilityCheckData>) =>
  queryOptions<
    ReportResponsibilityCheckResponse,
    DefaultError,
    ReportResponsibilityCheckResponse,
    ReturnType<typeof backendApiReportResponsibilityCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportResponsibilityCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportResponsibilityCheckQueryKey(options),
  });

export const backendApiReportImagesUploadQueryKey = (options: Options<ReportImagesUploadData>) =>
  createQueryKey('reportImagesUpload', options);

export const backendApiReportImagesUploadOptions = (options: Options<ReportImagesUploadData>) =>
  queryOptions<
    ReportImagesUploadResponse,
    DefaultError,
    ReportImagesUploadResponse,
    ReturnType<typeof backendApiReportImagesUploadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportImagesUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportImagesUploadQueryKey(options),
  });

export const backendApiReportImagesUploadMutation = (
  options?: Partial<Options<ReportImagesUploadData>>,
): UseMutationOptions<ReportImagesUploadResponse, DefaultError, Options<ReportImagesUploadData>> => {
  const mutationOptions: UseMutationOptions<
    ReportImagesUploadResponse,
    DefaultError,
    Options<ReportImagesUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportImagesUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportImagesFindOneQueryKey = (options: Options<ReportImagesFindOneData>) =>
  createQueryKey('reportImagesFindOne', options);

export const backendApiReportImagesFindOneOptions = (options: Options<ReportImagesFindOneData>) =>
  queryOptions<
    ReportImagesFindOneResponse,
    DefaultError,
    ReportImagesFindOneResponse,
    ReturnType<typeof backendApiReportImagesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportImagesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportImagesFindOneQueryKey(options),
  });

export const backendApiGeocoderGeocodeQueryKey = (options: Options<GeocoderGeocodeData>) =>
  createQueryKey('geocoderGeocode', options);

export const backendApiGeocoderGeocodeOptions = (options: Options<GeocoderGeocodeData>) =>
  queryOptions<
    GeocoderGeocodeResponse,
    DefaultError,
    GeocoderGeocodeResponse,
    ReturnType<typeof backendApiGeocoderGeocodeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiGeocoderGeocode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiGeocoderGeocodeQueryKey(options),
  });

export const backendApiGeocoderReverseQueryKey = (options: Options<GeocoderReverseData>) =>
  createQueryKey('geocoderReverse', options);

export const backendApiGeocoderReverseOptions = (options: Options<GeocoderReverseData>) =>
  queryOptions<
    GeocoderReverseResponse,
    DefaultError,
    GeocoderReverseResponse,
    ReturnType<typeof backendApiGeocoderReverseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiGeocoderReverse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiGeocoderReverseQueryKey(options),
  });

export const backendApiReportCategoriesFindAllQueryKey = (options?: Options<ReportCategoriesFindAllData>) =>
  createQueryKey('reportCategoriesFindAll', options);

export const backendApiReportCategoriesFindAllOptions = (options?: Options<ReportCategoriesFindAllData>) =>
  queryOptions<
    ReportCategoriesFindAllResponse,
    DefaultError,
    ReportCategoriesFindAllResponse,
    ReturnType<typeof backendApiReportCategoriesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportCategoriesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportCategoriesFindAllQueryKey(options),
  });

export const backendApiReportCategoriesCreateQueryKey = (options: Options<ReportCategoriesCreateData>) =>
  createQueryKey('reportCategoriesCreate', options);

export const backendApiReportCategoriesCreateOptions = (options: Options<ReportCategoriesCreateData>) =>
  queryOptions<
    ReportCategoriesCreateResponse,
    DefaultError,
    ReportCategoriesCreateResponse,
    ReturnType<typeof backendApiReportCategoriesCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportCategoriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportCategoriesCreateQueryKey(options),
  });

export const backendApiReportCategoriesCreateMutation = (
  options?: Partial<Options<ReportCategoriesCreateData>>,
): UseMutationOptions<ReportCategoriesCreateResponse, DefaultError, Options<ReportCategoriesCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ReportCategoriesCreateResponse,
    DefaultError,
    Options<ReportCategoriesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportCategoriesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiReportCategoriesFindOneQueryKey = (options: Options<ReportCategoriesFindOneData>) =>
  createQueryKey('reportCategoriesFindOne', options);

export const backendApiReportCategoriesFindOneOptions = (options: Options<ReportCategoriesFindOneData>) =>
  queryOptions<
    ReportCategoriesFindOneResponse,
    DefaultError,
    ReportCategoriesFindOneResponse,
    ReturnType<typeof backendApiReportCategoriesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiReportCategoriesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiReportCategoriesFindOneQueryKey(options),
  });

export const backendApiReportCategoriesUpdateMutation = (
  options?: Partial<Options<ReportCategoriesUpdateData>>,
): UseMutationOptions<ReportCategoriesUpdateResponse, DefaultError, Options<ReportCategoriesUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    ReportCategoriesUpdateResponse,
    DefaultError,
    Options<ReportCategoriesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiReportCategoriesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAdminLevelsFindAllQueryKey = (options?: Options<AdminLevelsFindAllData>) =>
  createQueryKey('adminLevelsFindAll', options);

export const backendApiAdminLevelsFindAllOptions = (options?: Options<AdminLevelsFindAllData>) =>
  queryOptions<
    AdminLevelsFindAllResponse,
    DefaultError,
    AdminLevelsFindAllResponse,
    ReturnType<typeof backendApiAdminLevelsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsFindAllQueryKey(options),
  });

export const backendApiAdminLevelsFindOneQueryKey = (options: Options<AdminLevelsFindOneData>) =>
  createQueryKey('adminLevelsFindOne', options);

export const backendApiAdminLevelsFindOneOptions = (options: Options<AdminLevelsFindOneData>) =>
  queryOptions<
    AdminLevelsFindOneResponse,
    DefaultError,
    AdminLevelsFindOneResponse,
    ReturnType<typeof backendApiAdminLevelsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsFindOneQueryKey(options),
  });

export const backendApiAdminLevelsUpdateMutation = (
  options?: Partial<Options<AdminLevelsUpdateData>>,
): UseMutationOptions<AdminLevelsUpdateResponse, DefaultError, Options<AdminLevelsUpdateData>> => {
  const mutationOptions: UseMutationOptions<AdminLevelsUpdateResponse, DefaultError, Options<AdminLevelsUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAdminLevelsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAdminLevelsRemoveAdminLevelUserMutation = (
  options?: Partial<Options<AdminLevelsRemoveAdminLevelUserData>>,
): UseMutationOptions<
  AdminLevelsRemoveAdminLevelUserResponse,
  DefaultError,
  Options<AdminLevelsRemoveAdminLevelUserData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminLevelsRemoveAdminLevelUserResponse,
    DefaultError,
    Options<AdminLevelsRemoveAdminLevelUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAdminLevelsRemoveAdminLevelUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAdminLevelsFindOneAdminLevelUserQueryKey = (
  options: Options<AdminLevelsFindOneAdminLevelUserData>,
) => createQueryKey('adminLevelsFindOneAdminLevelUser', options);

export const backendApiAdminLevelsFindOneAdminLevelUserOptions = (
  options: Options<AdminLevelsFindOneAdminLevelUserData>,
) =>
  queryOptions<
    AdminLevelsFindOneAdminLevelUserResponse,
    DefaultError,
    AdminLevelsFindOneAdminLevelUserResponse,
    ReturnType<typeof backendApiAdminLevelsFindOneAdminLevelUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsFindOneAdminLevelUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsFindOneAdminLevelUserQueryKey(options),
  });

export const backendApiAdminLevelsUpdateAdminLevelUserMutation = (
  options?: Partial<Options<AdminLevelsUpdateAdminLevelUserData>>,
): UseMutationOptions<
  AdminLevelsUpdateAdminLevelUserResponse,
  DefaultError,
  Options<AdminLevelsUpdateAdminLevelUserData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminLevelsUpdateAdminLevelUserResponse,
    DefaultError,
    Options<AdminLevelsUpdateAdminLevelUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAdminLevelsUpdateAdminLevelUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAdminLevelsCreateAdminLevelUserQueryKey = (
  options: Options<AdminLevelsCreateAdminLevelUserData>,
) => createQueryKey('adminLevelsCreateAdminLevelUser', options);

export const backendApiAdminLevelsCreateAdminLevelUserOptions = (
  options: Options<AdminLevelsCreateAdminLevelUserData>,
) =>
  queryOptions<
    AdminLevelsCreateAdminLevelUserResponse,
    DefaultError,
    AdminLevelsCreateAdminLevelUserResponse,
    ReturnType<typeof backendApiAdminLevelsCreateAdminLevelUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsCreateAdminLevelUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsCreateAdminLevelUserQueryKey(options),
  });

export const backendApiAdminLevelsCreateAdminLevelUserMutation = (
  options?: Partial<Options<AdminLevelsCreateAdminLevelUserData>>,
): UseMutationOptions<
  AdminLevelsCreateAdminLevelUserResponse,
  DefaultError,
  Options<AdminLevelsCreateAdminLevelUserData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminLevelsCreateAdminLevelUserResponse,
    DefaultError,
    Options<AdminLevelsCreateAdminLevelUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAdminLevelsCreateAdminLevelUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiRadvisImportImportBicycleNetworkQueryKey = (
  options?: Options<RadvisImportImportBicycleNetworkData>,
) => createQueryKey('radvisImportImportBicycleNetwork', options);

export const backendApiRadvisImportImportBicycleNetworkOptions = (
  options?: Options<RadvisImportImportBicycleNetworkData>,
) =>
  queryOptions<
    RadvisImportImportBicycleNetworkResponse,
    DefaultError,
    RadvisImportImportBicycleNetworkResponse,
    ReturnType<typeof backendApiRadvisImportImportBicycleNetworkQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiRadvisImportImportBicycleNetwork({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiRadvisImportImportBicycleNetworkQueryKey(options),
  });

export const backendApiRadvisImportImportBicycleNetworkMutation = (
  options?: Partial<Options<RadvisImportImportBicycleNetworkData>>,
): UseMutationOptions<
  RadvisImportImportBicycleNetworkResponse,
  DefaultError,
  Options<RadvisImportImportBicycleNetworkData>
> => {
  const mutationOptions: UseMutationOptions<
    RadvisImportImportBicycleNetworkResponse,
    DefaultError,
    Options<RadvisImportImportBicycleNetworkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiRadvisImportImportBicycleNetwork({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiRadvisImportImportRouteSignsQueryKey = (options?: Options<RadvisImportImportRouteSignsData>) =>
  createQueryKey('radvisImportImportRouteSigns', options);

export const backendApiRadvisImportImportRouteSignsOptions = (options?: Options<RadvisImportImportRouteSignsData>) =>
  queryOptions<
    RadvisImportImportRouteSignsResponse,
    DefaultError,
    RadvisImportImportRouteSignsResponse,
    ReturnType<typeof backendApiRadvisImportImportRouteSignsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiRadvisImportImportRouteSigns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiRadvisImportImportRouteSignsQueryKey(options),
  });

export const backendApiRadvisImportImportRouteSignsMutation = (
  options?: Partial<Options<RadvisImportImportRouteSignsData>>,
): UseMutationOptions<
  RadvisImportImportRouteSignsResponse,
  DefaultError,
  Options<RadvisImportImportRouteSignsData>
> => {
  const mutationOptions: UseMutationOptions<
    RadvisImportImportRouteSignsResponse,
    DefaultError,
    Options<RadvisImportImportRouteSignsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiRadvisImportImportRouteSigns({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiRadvisImportImportServiceStationsQueryKey = (
  options?: Options<RadvisImportImportServiceStationsData>,
) => createQueryKey('radvisImportImportServiceStations', options);

export const backendApiRadvisImportImportServiceStationsOptions = (
  options?: Options<RadvisImportImportServiceStationsData>,
) =>
  queryOptions<
    RadvisImportImportServiceStationsResponse,
    DefaultError,
    RadvisImportImportServiceStationsResponse,
    ReturnType<typeof backendApiRadvisImportImportServiceStationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiRadvisImportImportServiceStations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiRadvisImportImportServiceStationsQueryKey(options),
  });

export const backendApiRadvisImportImportServiceStationsMutation = (
  options?: Partial<Options<RadvisImportImportServiceStationsData>>,
): UseMutationOptions<
  RadvisImportImportServiceStationsResponse,
  DefaultError,
  Options<RadvisImportImportServiceStationsData>
> => {
  const mutationOptions: UseMutationOptions<
    RadvisImportImportServiceStationsResponse,
    DefaultError,
    Options<RadvisImportImportServiceStationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiRadvisImportImportServiceStations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiDashboardAnalyzeQueryKey = (options: Options<DashboardAnalyzeData>) =>
  createQueryKey('dashboardAnalyze', options);

export const backendApiDashboardAnalyzeOptions = (options: Options<DashboardAnalyzeData>) =>
  queryOptions<
    DashboardAnalyzeResponse,
    DefaultError,
    DashboardAnalyzeResponse,
    ReturnType<typeof backendApiDashboardAnalyzeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiDashboardAnalyze({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiDashboardAnalyzeQueryKey(options),
  });

export const backendApiDashboardAnalyzeMutation = (
  options?: Partial<Options<DashboardAnalyzeData>>,
): UseMutationOptions<DashboardAnalyzeResponse, DefaultError, Options<DashboardAnalyzeData>> => {
  const mutationOptions: UseMutationOptions<DashboardAnalyzeResponse, DefaultError, Options<DashboardAnalyzeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiDashboardAnalyze({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiExternalReportsTestQueryKey = (options: Options<ExternalReportsTestData>) =>
  createQueryKey('externalReportsTest', options);

export const backendApiExternalReportsTestOptions = (options: Options<ExternalReportsTestData>) =>
  queryOptions<
    ExternalReportsTestResponse,
    DefaultError,
    ExternalReportsTestResponse,
    ReturnType<typeof backendApiExternalReportsTestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiExternalReportsTest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiExternalReportsTestQueryKey(options),
  });

export const backendApiExternalReportsGetCategoriesQueryKey = (options: Options<ExternalReportsGetCategoriesData>) =>
  createQueryKey('externalReportsGetCategories', options);

export const backendApiExternalReportsGetCategoriesOptions = (options: Options<ExternalReportsGetCategoriesData>) =>
  queryOptions<
    ExternalReportsGetCategoriesResponse,
    DefaultError,
    ExternalReportsGetCategoriesResponse,
    ReturnType<typeof backendApiExternalReportsGetCategoriesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiExternalReportsGetCategories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiExternalReportsGetCategoriesQueryKey(options),
  });

export const backendApiExternalReportsCreateQueryKey = (options: Options<ExternalReportsCreateData>) =>
  createQueryKey('externalReportsCreate', options);

export const backendApiExternalReportsCreateOptions = (options: Options<ExternalReportsCreateData>) =>
  queryOptions<
    ExternalReportsCreateResponse,
    DefaultError,
    ExternalReportsCreateResponse,
    ReturnType<typeof backendApiExternalReportsCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiExternalReportsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiExternalReportsCreateQueryKey(options),
  });

export const backendApiExternalReportsCreateMutation = (
  options?: Partial<Options<ExternalReportsCreateData>>,
): UseMutationOptions<ExternalReportsCreateResponse, DefaultError, Options<ExternalReportsCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ExternalReportsCreateResponse,
    DefaultError,
    Options<ExternalReportsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiExternalReportsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiExternalReportsGetStatusQueryKey = (options: Options<ExternalReportsGetStatusData>) =>
  createQueryKey('externalReportsGetStatus', options);

export const backendApiExternalReportsGetStatusOptions = (options: Options<ExternalReportsGetStatusData>) =>
  queryOptions<
    ExternalReportsGetStatusResponse,
    DefaultError,
    ExternalReportsGetStatusResponse,
    ReturnType<typeof backendApiExternalReportsGetStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiExternalReportsGetStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiExternalReportsGetStatusQueryKey(options),
  });

export const backendApiSystemNotificationsFindAllQueryKey = (options?: Options<SystemNotificationsFindAllData>) =>
  createQueryKey('systemNotificationsFindAll', options);

export const backendApiSystemNotificationsFindAllOptions = (options?: Options<SystemNotificationsFindAllData>) =>
  queryOptions<
    SystemNotificationsFindAllResponse,
    DefaultError,
    SystemNotificationsFindAllResponse,
    ReturnType<typeof backendApiSystemNotificationsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSystemNotificationsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSystemNotificationsFindAllQueryKey(options),
  });

export const backendApiSystemNotificationsCreateQueryKey = (options: Options<SystemNotificationsCreateData>) =>
  createQueryKey('systemNotificationsCreate', options);

export const backendApiSystemNotificationsCreateOptions = (options: Options<SystemNotificationsCreateData>) =>
  queryOptions<
    SystemNotificationsCreateResponse,
    DefaultError,
    SystemNotificationsCreateResponse,
    ReturnType<typeof backendApiSystemNotificationsCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSystemNotificationsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSystemNotificationsCreateQueryKey(options),
  });

export const backendApiSystemNotificationsCreateMutation = (
  options?: Partial<Options<SystemNotificationsCreateData>>,
): UseMutationOptions<SystemNotificationsCreateResponse, DefaultError, Options<SystemNotificationsCreateData>> => {
  const mutationOptions: UseMutationOptions<
    SystemNotificationsCreateResponse,
    DefaultError,
    Options<SystemNotificationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSystemNotificationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSystemNotificationsRemoveMutation = (
  options?: Partial<Options<SystemNotificationsRemoveData>>,
): UseMutationOptions<SystemNotificationsRemoveResponse, DefaultError, Options<SystemNotificationsRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    SystemNotificationsRemoveResponse,
    DefaultError,
    Options<SystemNotificationsRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSystemNotificationsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSystemNotificationsFindOneQueryKey = (options: Options<SystemNotificationsFindOneData>) =>
  createQueryKey('systemNotificationsFindOne', options);

export const backendApiSystemNotificationsFindOneOptions = (options: Options<SystemNotificationsFindOneData>) =>
  queryOptions<
    SystemNotificationsFindOneResponse,
    DefaultError,
    SystemNotificationsFindOneResponse,
    ReturnType<typeof backendApiSystemNotificationsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSystemNotificationsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSystemNotificationsFindOneQueryKey(options),
  });

export const backendApiSystemNotificationsUpdateMutation = (
  options?: Partial<Options<SystemNotificationsUpdateData>>,
): UseMutationOptions<SystemNotificationsUpdateResponse, DefaultError, Options<SystemNotificationsUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    SystemNotificationsUpdateResponse,
    DefaultError,
    Options<SystemNotificationsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSystemNotificationsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
